export const QuestionTypes = {
  uniqueOption: 'uniqueOption',
  linearScale: 'linearScale',
  yesNo: 'yesNo',
  section: 'section',
  multipleChoice: 'multiple choice',
  squares: 'squares'
};
